module.exports = __webpack_public_path__ + "img/徐军.03784edc.png";